export default __webpack_public_path__ + "static/media/HT.3d3775cd.svg";